import { render, staticRenderFns } from "./productAppointmentShort.vue?vue&type=template&id=5a81c672&scoped=true"
import script from "./productAppointmentShort.vue?vue&type=script&lang=js"
export * from "./productAppointmentShort.vue?vue&type=script&lang=js"
import style0 from "./productAppointmentShort.vue?vue&type=style&index=0&id=5a81c672&prod&lang=scss&scoped=true"
import style1 from "./productAppointmentShort.vue?vue&type=style&index=1&id=5a81c672&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a81c672",
  null
  
)

export default component.exports